export const Activities = {
    Development : "Entwicklung",
    Consulting : "Beratung / Konzeption",
    Meeting : "Meeting / Abstimmung",
    HTML : "HTML",
    Graphics : "Grafik",

}